exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.bottom-space {\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.no-bottom-space {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.statistics-close-btn {\r\n}\r\n\r\n.todo-close-btn {\r\n    margin: 0 10px -25px 0;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.banner-close-btn {\r\n    margin: 0 10px -25px 0;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/quote-home/quote-home.component.css
// module id = 575
// module chunks = 0